import { Component, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { AppState, Store } from '../../../../store/app.models';

@Component({
  selector: 'app-location-report',
  templateUrl: './location-report.component.html',
  styleUrls: ['./location-report.component.css']
})
export class LocationReportComponent extends ReportBase implements OnInit {

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/location-report/location-report.component.ts